/** Matches https://icctmemphis.org/information/contact-us/ subject options */
export const CONTACT_SUBJECT_OPTIONS = [
  'General Enquiries',
  'Annadanam',
  'Donation / Payment',
  'Events',
  'Facilities',
  'Personal Services',
  'My Account',
  'Website',
  'Volunteering',
  'Kotilinga Kshetram',
  'Other',
];
